import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { ThemeViewStore } from "../../store";
import { ThemeView } from "./ThemeView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type ThemeDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const ThemeDrawerContent: React.FC<ThemeDrawerContentProps> = observer(
  ({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new ThemeViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return <ThemeView themeViewStore={viewStore} />;
  }
);
